<template>
  <el-menu :collapse="props.collapse" :default-active="props.selectedKey" :default-openeds="props.openKeys" collapse-transition unique-opened
           @open="changeOpenKeys"
           @select="changeSelectedKey">
    <template v-for="item in props.menus">
      <!--存在二级菜单-->
      <template v-if="item.child.length > 0">
        <el-sub-menu :index="item.path" :key="item.path">
          <template #title>
            <i class="el-icon" :class="item.icon"></i>
            <span>{{ item.name }}</span>
          </template>
          <!--存在三级菜单-->
          <template v-for="subItem in item.child">
            <el-sub-menu v-if="subItem.child.length > 0" :index="subItem.path" :key="subItem.path">
              <template #title>
                <span>{{ subItem.name }}</span>
              </template>
              <el-menu-item v-for="(threeItem, i) in subItem.child" :key="i" :index="threeItem.path" :title="subItem.name"></el-menu-item>
            </el-sub-menu>
            <el-menu-item v-else :index="subItem.path" :key="subItem.path">
              <template #title>
                <span>{{ subItem.name }}</span>
              </template>
            </el-menu-item>
          </template>
        </el-sub-menu>
      </template>
      <template v-else>
        <el-menu-item :index="item.path" :key="item.path">
          <i class="el-icon" :class="item.icon"></i>
          <template #title>
            <span>{{ item.name }}</span>
          </template>
        </el-menu-item>
      </template>
    </template>
  </el-menu>
</template>

<script>
export default {
  name: "GlobalMenu",
};
</script>

<script setup>
import {defineEmits,defineProps} from "vue";
const props = defineProps({
  collapse:{
    type:Boolean,
    default:false
  },
  menus: {},
  selectedKey:{
    type:String,
    default:''
  },
  openKeys:{
    type:[String,Array],
    default:''
  }
});

const emits = defineEmits(['changeOpenKeys', 'changeSelectedKey'])

const changeOpenKeys = (index) => {
  emits("changeOpenKeys", index);
}

const changeSelectedKey = (index) => {
  emits("changeSelectedKey", index);
};

</script>

<style scoped>

</style>
